"use strict";
// The `isPointer` function determines if its argument is a valid json pointer
// or not returning a boolean indicating the result of the operation.
Object.defineProperty(exports, "__esModule", { value: true });
// ## Implementation
exports.isPointer = (input) => {
    // A JSON `pointer` must begin with the symbols '#', '/' or be an empty string
    // ''.
    if (typeof input !== 'string') {
        return false;
    }
    if (input === '') {
        return true;
    }
    if (/^#|^\//.test(input)) {
        return true;
    }
    // If it is not one of these values then `input` is not a json pointer.
    return false;
};
//# sourceMappingURL=isPointer.js.map